import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY);

export const StripeElementsRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    return (
        <Elements
            stripe={stripePromise}
            options={{
                mode: 'subscription',
                amount: 500, // $5.00 in cents
                currency: 'usd',
                paymentMethodCreation: 'manual',
                appearance: {
                    theme: 'stripe',
                },
            }}
        >
            {children}
        </Elements>
    );
};
